import images from "./images"

export function inithelpers(app)
{
    app.config.globalProperties.$images = images;    
}